module.exports = __webpack_public_path__ + "img/mpe3.0c7c727a.png";